import { render, staticRenderFns } from "./r-recipe-dialog.vue?vue&type=template&id=ccbaf4b4&scoped=true"
import script from "./r-recipe-dialog.vue?vue&type=script&lang=js"
export * from "./r-recipe-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-recipe-dialog.vue?vue&type=style&index=0&id=ccbaf4b4&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbaf4b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ccbaf4b4')) {
      api.createRecord('ccbaf4b4', component.options)
    } else {
      api.reload('ccbaf4b4', component.options)
    }
    module.hot.accept("./r-recipe-dialog.vue?vue&type=template&id=ccbaf4b4&scoped=true", function () {
      api.rerender('ccbaf4b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/recipe/r-recipe-dialog.vue"
export default component.exports